"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DAYS_OF_WEEK = void 0;
const react_1 = __importDefault(require("react"));
const button_1 = __importDefault(require("@kyruus/button"));
const styles_1 = require("./styles");
exports.DAYS_OF_WEEK = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
];
function WeekDayFilter({ filterBy, onChange }) {
    const handleClick = (index, day) => {
        const nextDayOfWeek = new Set(filterBy.dayOfWeek);
        if (nextDayOfWeek.has(index)) {
            nextDayOfWeek.delete(index);
        }
        else {
            nextDayOfWeek.add(index);
        }
        onChange(nextDayOfWeek, day);
    };
    return (react_1.default.createElement(styles_1.Container, { "data-testid": "WeekDayFilter" }, exports.DAYS_OF_WEEK.map((day, index) => (react_1.default.createElement("li", { key: day },
        react_1.default.createElement(button_1.default, { "aria-label": day, title: day, mode: filterBy.dayOfWeek.has(index) ? 'primary' : 'secondary', onClick: () => handleClick(index, day) }, day.charAt(0)))))));
}
exports.default = WeekDayFilter;
//# sourceMappingURL=WeekDayFilter.js.map